import {
  UPDATE_OPPORTUNITIES_TOTAL_COUNT,
} from '../actionTypes';

let initialState = []

export default function opportunitiesTotalCount(state = initialState, action) {
  switch(action.type) {
    case UPDATE_OPPORTUNITIES_TOTAL_COUNT:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/projectFinder/reducers/opportunitiesTotalCount.js